<template>
  <el-dialog
    width="25%"
    :title="!dataForm.storeId ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmit()"
      label-width="90px"
    >
      <el-form-item label="店铺名称" prop="storeName">
        <!-- :disabled="this.dataForm.storeId?true:false" -->
        <el-input v-model="dataForm.storeName" placeholder="请输入店铺名称" maxlength="50"></el-input>
      </el-form-item>
      <el-form-item label="所属区域" prop="districtId">
        <el-select v-model="dataForm.districtId" placeholder="请选择" style="width:100%;" clearable>
          <el-option
            v-for="item in areaList"
            :key="item.districtId"
            :label="item.districtName"
            :value="item.districtId"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { storeAdd } from '../api'
export default {
  props:{
    areaList:{
      type: Array,
      default: []
    }
  },
  data() {
    return {
      visible: false,
      dataForm: {
        storeId: "",
        districtName: "",
        districtId: "",
        storeName: "",
      },
      dataRule: {
        storeName: [
          { required: true, message: '店铺名不能为空', trigger: 'blur' }
        ],
        districtId: [
          { required: true, message: '请选择区域', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    init(data) {
      this.dataForm.storeId = data?data.storeId:'';
      this.visible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        if(data) {
          this.dataForm.districtId = data.districtId;
          this.dataForm.districtName =  data.districtName;
          this.dataForm.storeName = data.storeName;
          this.dataForm.storeId = data.storeId;
          this.dataForm = JSON.parse(JSON.stringify(this.dataForm));
          console.log(this.dataForm)
        } else {
          this.dataForm = {};
        }
      });
    },
    // 获取地区名
    getAreaName(even) {
      this.areaList.forEach(item => {
        if(this.dataForm.districtId == item.districtId){
          this.dataForm.districtName = item.districtName;
        }
      })
    },
    // 表单提交
    dataFormSubmit() {
      this.getAreaName();
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          // 店铺新增
          storeAdd({
              districtId: this.dataForm.districtId,
              districtName: this.dataForm.districtName,
              storeName: this.dataForm.storeName,
              storeId: this.dataForm.storeId
          }).then(data => {
            if (data && data.code === 0) {
              this.$message({
                message: "操作成功",
                type: "success",
                duration: 500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
              this.dataForm = {}
            } else {
              this.$message.error(data.msg);
            }
          });
        } else {
          this.$message.error('请填写完整内容！');
        }
      });
    },
  },
};
</script>
